module.exports = __webpack_public_path__ + "static/img/left.971ff6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/left.png
// module id = rxuo
// module chunks = 2